import Main from "_c/main"

export default {
    path: "/",
    name: "",
    component: Main,
    children: [
        {
            path: "/salesman",
            name: "salesman",
            component: () => import('@/view/salesman'),
            meta:{
                parent:true,
                parentName:"salesman",
                name:"业务",
                assess:true
            },
            children: [
                {
                    path: "business",
                    name: "business",
                    component: () => import("@/view/salesman/business"),
                    meta:{
                        parent:false,
                        parentName:"salesman",
                        name:"业务员",
                        assess:true
                    }
                },
            ]
        }
    ]

}


// WEBPACK FOOTER //
// ./src/router/modules/salesman.js